import * as React from "react";
import { printDateToChat } from "@/utils";

interface MessageChat {
  type: "LEFT" | "RIGHT";
  owner?: string;
  date?: string;
  message: string;
}

interface OwnProps {
  messages: MessageChat[];
}

type Props = OwnProps;

/**
 * Compliance Modal - Chat Bubble Detail refactored to Tailwind
 */
export const ComplianceBubbleDetails: React.FC<Props> = ({ messages }) => {
  return (
    <div className="flex flex-col gap-4 w-full py-2">
      {messages &&
        messages.map(({ owner, date, message, type }, index) => {
          const isRight = type === "RIGHT";
          return (
            <div
              key={"bubble_" + index}
              className={`flex flex-col max-w-[85%] ${isRight ? "self-end items-end" : "self-start items-start"}`}
            >
              {owner && (
                <div className="text-[11px] text-slate-400 font-semibold mb-1 flex items-center gap-1.5 px-1 select-none">
                  <span className="text-slate-600">{owner}</span>
                  <span>•</span>
                  <span>{printDateToChat(date)}</span>
                </div>
              )}
              <div
                className={`p-3 rounded-2xl text-sm leading-relaxed whitespace-pre-wrap break-words ${
                  isRight
                    ? "bg-indigo-500 text-white rounded-tr-none shadow-sm"
                    : "bg-slate-100 text-slate-800 rounded-tl-none"
                }`}
              >
                <p className="m-0 select-text selection:bg-indigo-200">{message}</p>
              </div>
            </div>
          );
        })}
    </div>
  );
};
